import { Injectable } from '@angular/core';
import { type ChatBotChain, type ChatBotChainEntity, ChatBotChainTriggerType } from '@common/types/chat-bot-chain.type';

@Injectable({
    providedIn: 'root',
})
export class ChatBotChainsService {
    public normalizeChatBotChains(chatBotChains: ChatBotChain[]): ChatBotChainEntity[] {
        return chatBotChains.map((chatBotChain) => {
            return {
                chainId: chatBotChain._id,
                name: chatBotChain.name,
                isDefault: chatBotChain.triggers.some((trigger) => trigger.type === ChatBotChainTriggerType.Default),
            };
        });
    }
}
